import urlParse from 'url-parse';

/**
 * get url of the current page and check 
 * if the current page is belong to this
 * plugin or not
 * 
 * @param {window.location.href} url 
 */

export const isInPlugin = (url) => {
    if (!url) return;

    const parse = urlParse(url);
    const query = parse.query || "";

    return new RegExp('.*best_push.*').test(query);
}